module.exports = __webpack_public_path__ + "static/media/ic_show_similar_hover.4c4399e9.svg";